import { ComponentType, ReactNode } from 'react';
import { ArcadiaActionsModal } from '../../pages/ConnectedAccountsPage/ArcadiaMenuItem/ArcadiaActionsModal';
import { ArcadiaRemoveConfirmationModal } from '../../pages/ConnectedAccountsPage/ArcadiaMenuItem/ArcadiaRemoveConfirmationModal';
import PocModal from '../../pages/HomePage/components/PocModal';
import ProjectSummaryListBottomSheet from '../../pages/HomePage/components/ProjectComponents/ProjectSummaryListBottomSheet/ProjectSummaryListBottomSheet';
import { CouponIssuanceModal } from '../../pages/ProductDetailPage/ProductOverview/components/CouponIssuanceModal';
import { ManufacturersFilterModal } from '../../pages/ShopSearchPage/ProductFilters/ManufacturerFilter/ManufacturersFilterModal';
import { ExistingProjectModal } from '../../pages/ProjectDetail/components/ExistingProjectModal/ExistingProjectModal';
import { OnboardingTimeoutModal } from '../../pages/ProjectDetail/components/OnboardingTimeoutModal/OnboardingTimeoutModal';
import { PriceFilterModal } from '../../pages/ShopSearchPage/ProductFilters/PriceFilter/PriceFilterModal';
import { SavingsExplainerModal } from '../../pages/ElectricityUsageAndSolarPage/content/SolarSavingsContent/components/savingsExplainer/SavingsExplainerModal';
import { ModalV3ContextProvider, ModalV3Id, useModalV3, useModalV3Context } from '@helios/frontend-project';

interface ModalV3ComponentProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const MODAL_V3_COMPONENT_MAP: Record<ModalV3Id, ComponentType<ModalV3ComponentProps>> = {
  [ModalV3Id.ARCADIA_ACTIONS]: ArcadiaActionsModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.ARCADIA_REMOVE_CONFIRMATION]: ArcadiaRemoveConfirmationModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.POC_MODAL]: PocModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.PROJECT_SUMMARY_LIST]: ProjectSummaryListBottomSheet as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.COUPON_ISSUANCE]: CouponIssuanceModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.PRICE_FILTER]: PriceFilterModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.MANUFACTURERS_FILTER]: ManufacturersFilterModal as ComponentType<ModalV3ComponentProps>,
  [ModalV3Id.EXISTING_PROJECT]: ExistingProjectModal,
  [ModalV3Id.ONBOARDING_TIMEOUT]: OnboardingTimeoutModal,
  [ModalV3Id.SAVINGS_EXPLAINER]: SavingsExplainerModal,
};

interface ModalV3ProviderProps {
  children: ReactNode;
}

export const ModalV3Provider = ({ children }: ModalV3ProviderProps) => {
  const { modalV3State, openModalV3, closeModalV3 } = useModalV3();

  return (
    <ModalV3ContextProvider openModalV3={openModalV3} closeModalV3={closeModalV3} modalV3State={modalV3State}>
      {children}
    </ModalV3ContextProvider>
  );
};

export const ModalV3Renderer = () => {
  const { modalV3State, closeModalV3 } = useModalV3Context();

  if (!modalV3State.current) {
    return null;
  }

  const ModalV3Component = MODAL_V3_COMPONENT_MAP[modalV3State.current.id];

  if (!ModalV3Component) {
    return null;
  }

  return <ModalV3Component isOpen={modalV3State.isOpen} onDismiss={closeModalV3} {...modalV3State.current.props} />;
};
